module.exports = new Promise(resolve => {
      // 版本两分钟内不变
      const version = Math.round(Date.now() / 120000);
      const remoteUrlWithVersion = '/webinar_brand/remoteEntry.js?t=' + version;
      const script = document.createElement('script')
      script.src = remoteUrlWithVersion
      script.onload = () => {
        const proxy = {
          get: (request) => window.webinarBrand.get(request),
          init: (arg) => {
            try {
              return window.webinarBrand.init(arg)
            } catch(e) {
              console.log('remote container already initialized')
            }
          }
        }
        resolve(proxy)
      }
      document.head.appendChild(script);
    });